import { Cropper } from 'cropperjs';
import { Dimension } from './interfaces';

export const calculateAspectRatio = (dimension: Dimension): number => {
  return dimension.width / dimension.height;
};

export const getNaturalCropDimensions = (cropper: Cropper): Dimension => {
  const cropBoxData = cropper.getCropBoxData();
  const imageData = cropper.getImageData();
  const scaleX = imageData.naturalWidth / imageData.width;
  const scaleY = imageData.naturalHeight / imageData.height;

  return {
    width: cropBoxData.width * scaleX,
    height: cropBoxData.height * scaleY,
  };
};

export const getDisplayMinCropSize = (
  cropper: Cropper,
  minDimension: Dimension
): Dimension => {
  const imageData = cropper.getImageData();
  const scaleX = imageData.width / imageData.naturalWidth;
  const scaleY = imageData.height / imageData.naturalHeight;

  return {
    width: minDimension.width * scaleX,
    height: minDimension.height * scaleY,
  };
};

export const meetsMinDimension = (
  width: number,
  height: number,
  minDimension: Dimension,
  tolerance = 1
): boolean => {
  return (
    width >= minDimension.width - tolerance &&
    height >= minDimension.height - tolerance
  );
};

export const imageMeetsMinDimension = (
  image: HTMLImageElement,
  minDimension: Dimension
): boolean => {
  return (
    image.naturalWidth >= minDimension.width &&
    image.naturalHeight >= minDimension.height
  );
};
